import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface StatusMessageProps extends HTMLAttributes<HTMLDivElement> {
  icon: ReactNode;
  children: ReactNode;
}

export function StatusMessage({ icon, children, className, ...rest }: StatusMessageProps) {
  return (
    <div className={cn('flex flex-col items-center gap-4', className)} {...rest}>
      {icon}
      <p className="font-inter text-xs font-normal leading-tight text-grey antialiased text-center">
        {children}
      </p>
    </div>
  );
}
